<template>
    <b-row class="tomate-cafe cursor-pointer">
        <b-col v-if="cafe" lg="12" cols="12" class="tomate-cafe-content"
              @click="goRouter('/contacto')"
        >
        <!--  @mouseover="changebackground(false)" @mouseleave=changebackground(true) -->
            <img class="tomate-cafe-img-tasa" :src="srcImagen('taza.gif')" alt="Taza imagen ">
            <img class="tomate-cafe-img" :src="srcImagen('nube.svg')" alt="Taza imagen">
            <p class="tomate-cafe-text1" v-html="content.texto1"></p>
        </b-col>
        <!-- <b-col v-if="!cafe" lg="12" cols="12" class="tomate-cafe-content"
               @mouseover="changebackground2(false)" @mouseleave=changebackground2(true)
               @click="openContacto()">
            <img class="tomate-cafe-img-comencemos" :src="srcImagen('comencemos.png')">
            <b-row class="tomate-cafe-content-comencemos">
                <b-col lg="10" cols="10"><p class="tomate-cafe-text2" v-html="content.texto2"></p></b-col>
                <b-col lg="2" cols="2" class="tomate-cafe-content-arrow">
                    <img class="tomate-cafe-img-arrow" :src="srcImagen('arrow_left_white.svg')">
                </b-col>
            </b-row>
        </b-col> -->
        <b-modal
                hide-footer
                centrado
                headerClass="p-2 border-bottom-0"
                id="formulario-contacto-gox"
                content-class="tomate-cafe-modal">
            <template  v-slot:modal-header="{ close }">
                <div class="w-100">
                    <img class="cursor-pointer float-right" :src="srcImagen('close.svg')"  @click="close()" alt="Close Svg">
                    <p class="my-4 tomate-cafe-titulo-form" v-html="content.texto_formulario"></p>
                </div>
            </template>
            <template v-slot:default>
                <formulario :content="formulario"/>
            </template>
        </b-modal>
    </b-row>
</template>
<script>
    import Formulario from '@/components/Formulario'

    export default {
        name: 'section-cafe',
        components: {Formulario},
        props: {
            content: Object
        },
        data: () => ({
            cafe: true,
            fijar: false,
            showDialog: false,
            formulario: {
                class_color: 'formulario-black',
                text_boton: 'Agendar',
                boton_img: true
            }
        }),
        methods: {
            srcImagen(img) {
                let src = require('@/assets/images/commerce_internal/' + img)
                return src
            },
            changebackground(value) {
                this.cafe = value
            },
            changebackground2(value) {
                if (!this.fijar) {
                    this.cafe = value
                } else {
                    this.cafe = false
                }
            },
            openContacto() {
                this.fijar = true
                this.cafe = false
                this.$bvModal.show('formulario-contacto-gox')
            },
            goRouter(url) {
                this.$router.push(url)
            }
        }
    }
</script>
<style scoped>
</style>